import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id D97DE718-4746-41B5-9168-4F5F08513158
 * name file-star-four-points-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-star-four-points-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileStarFourPointsOutlineIcon = createSvgIcon(<><path d="M12 11L10.74 13.75L8 15L10.74 16.26L12 19L13.25 16.26L16 15L13.25 13.75L12 11M6 2H14L20 8V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2M6 4V20H18V9H13V4H6Z" /></>, 'FileStarFourPointsOutlineIcon');
export default FileStarFourPointsOutlineIcon